import { render } from "./HelloWorld.vue?vue&type=template&id=060173c6&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=060173c6&scoped=true&lang=css"
import "./HelloWorld.vue?vue&type=style&index=1&id=060173c6&scoped=true&lang=css"

import exportComponent from "E:\\work\\mirror-chat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060173c6"]])

export default __exports__